import { Component } from '@nicolas-riciotti/light2';
import Lenis from '../../helpers/Lenis'

const INITIAL_VISIBLE_LIMIT = 20;
const LOAD_MORE_INCREMENT = 20;


function normalizeText(str = '') {
  return str
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9\s]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function levenshtein(a, b) {
  if (a === b) return 0;
  const alen = a.length, blen = b.length;
  if (!alen) return blen;
  if (!blen) return alen;
  // use 1D DP
  const v = new Array(blen + 1);
  for (let j = 0; j <= blen; j++) v[j] = j;
  for (let i = 1; i <= alen; i++) {
    let prev = v[0];
    v[0] = i;
    const ai = a.charCodeAt(i - 1);
    for (let j = 1; j <= blen; j++) {
      const tmp = v[j];
      const cost = ai === b.charCodeAt(j - 1) ? 0 : 1;
      v[j] = Math.min(
        v[j] + 1,        // deletion
        v[j - 1] + 1,    // insertion
        prev + cost      // substitution
      );
      prev = tmp;
    }
  }
  return v[blen];
}

function maxEdits(len) {
  if (len <= 2) return 0;
  if (len <= 4) return 1;
  if (len <= 7) return 2;
  return 3;
}

function tokenMatchesTitleWord(qTok, tTok) {
  if (!qTok) return true;
  if (tTok === qTok) return true;
  // nice UX: allow prefix typing (not “autocomplete”, just matching)
  if (tTok.startsWith(qTok)) return true;
  // typo-tolerant: compare against prefix of title word (handles "desu" vs "design")
  const target = (tTok.length >= qTok.length) ? tTok.slice(0, qTok.length) : tTok;
  const dist = levenshtein(qTok, target);
  return dist <= maxEdits(qTok.length);
}

function fuzzyMatchAllTokens(queryNorm, titleWords) {
  if (!queryNorm) return true;
  const qWords = queryNorm.split(' ').filter(w => w.length >= 2); // ignore 1-letter noise
  if (qWords.length === 0) return true;
  return qWords.every(qw => titleWords.some(tw => tokenMatchesTitleWord(qw, tw)));
}


export default class BlockCareers extends Component {

  attached() {

    const $searchInput     = this.querySelector('[data-search-input]');
    const $searchClear     = this.querySelector('[data-search-clear]');

    const $resultsCounter  = this.querySelector('[data-results-counter]');
    const $selectedFilters = this.querySelector('[data-selected-filters]');


    const $regionFilters     = this.querySelectorAll('[data-region-filter]');
    const $disciplineFilters = this.querySelectorAll('[data-discipline-filter]');
    const $categoryFilters   = this.querySelectorAll('[data-category-filter]');
    const $slides            = this.querySelectorAll('[data-slide]');
    const $loadMoreBtn       = document.getElementById('load-more');

    const $noResultsMessage  = document.getElementById('no-results-message');
    const $jobsContainer     = document.getElementById('jobs-container');

    const $filtersMenuReset = this.querySelector('[data-filter-menu-reset]');
    const $viewJobsButton  = this.querySelector('[data-view-jobs-button]');

    function resetQuery() {
      query = '';
      $searchInput.value = '';
      $searchClear.style.display = 'none';
    }

    function hasfilters() {
      return query !== '' || selectedDiscipline !== '' || selectedRegions.length > 0 || selectedCategory !== '';
    }

    function filter() {
      visibleLimit = INITIAL_VISIBLE_LIMIT;
      updateAllFilters();
      filterPosts();
      updateURL();
      updateTagStates();
      $filtersMenuReset.style.opacity = hasfilters() ? 1 : 0;
    }
    
    $searchClear.addEventListener('click', e => {
      resetQuery();
      filter();
    });

    const $filtersReset = this.querySelectorAll('[data-filter-reset]');
    $filtersReset?.forEach(el => {
      el.addEventListener('click', e => {
        selectedDiscipline = '';
        selectedRegions.length = 0;
        selectedCategory = '';
        resetQuery();
        filter()
        if (window.innerWidth <= 768) {
          requestAnimationFrame(()=>{
            $filtersMenu.querySelector('app-dropdown').open();
          });
        }
      });
    })

    const $filtersMenuToggle = this.querySelectorAll('[data-filter-menu-toggle]');
    const $filtersMenu = this.querySelector('[data-filter-menu]');
    let isFiltersMenuOpened = false;
    $filtersMenuToggle?.forEach(el => {
      el.addEventListener('click', e => {
        isFiltersMenuOpened = !isFiltersMenuOpened;

        Lenis?.[isFiltersMenuOpened?'stop':'start']();

        $filtersMenu.classList[isFiltersMenuOpened ? 'add' : 'remove']('is-opened');
        $filtersMenu.setAttribute('aria-hidden', !isFiltersMenuOpened);
        if (isFiltersMenuOpened) {
          requestAnimationFrame(()=>{
            $filtersMenu.querySelector('app-dropdown').open();
          })
        }
      });
    })
          
          

    const cleanTitles = {
      region: {},
      discipline: {},
      category: {},
    };
    [
      { elements: $regionFilters, name: 'region' },
      { elements: $disciplineFilters, name: 'discipline' },
      { elements: $categoryFilters, name: 'category' },
    ].forEach(({ elements, name }) => {
      elements.forEach(input => {
        if (input.value === 'all') return;
        const title = input.getAttribute('data-title');
        if (!title) return;
        cleanTitles[name][input.value] = title;
      });
    });

    console.log("cleanTitles", cleanTitles);


    const slides = [];
    $slides.forEach((el,i)=>{
      const regions = el.getAttribute('data-regions').split(',');
      const discipline = el.getAttribute('data-discipline');
      const category = el.getAttribute('data-category');
      const title = el.getAttribute('data-title');
      const titleNorm = normalizeText(title);
      const titleWords = titleNorm.split(' ').filter(Boolean);
      slides.push({ el, regions, discipline, category, title, titleNorm, titleWords });
    });


    let query = '';
    let selectedRegions = [];
    let selectedDiscipline = '';
    let selectedCategory = '';
    let visibleLimit = INITIAL_VISIBLE_LIMIT; // show first 5 initially

    const params = new URLSearchParams(window.location.search);

    const regions = params.get('selected_regions');
    if (regions) {
      selectedRegions = regions.split(',');
    }
    const discipline = params.get('selected_discipline');
    if (discipline) {
      selectedDiscipline = discipline;
    }

    // -----------------------------
    // Helpers to handle filtering
    // -----------------------------

    function getAvailableOptions(filterType, selectedDiscipline, selectedRegions, selectedCategory) {
      const availableOptions = new Set();

      slides.forEach(slide => {
        // Check if slide matches current filters
        const matchesDiscipline = !selectedDiscipline || selectedDiscipline === slide.discipline;
        const matchesRegion = selectedRegions.length === 0 ||
          slide.regions.some(region => selectedRegions.includes(region));
        const matchesCategory = !selectedCategory || selectedCategory === slide.category;

        if (matchesDiscipline && matchesRegion && matchesCategory) {
          // Add the appropriate option based on filterType
          if (filterType === 'discipline') {
            availableOptions.add(slide.discipline);
          } else if (filterType === 'region') {
            slide.regions.forEach(region => {
              if (region) availableOptions.add(region);
            });
          } else if (filterType === 'category') {
            if (slide.category) availableOptions.add(slide.category);
          }
        }
      });

      return Array.from(availableOptions);
    }

    function getRegionsForDiscipline(discipline) {
      return getAvailableOptions('region', discipline, [], selectedCategory);
    }

    function getDisciplinesForRegions(regions) {
      return getAvailableOptions('discipline', '', regions, selectedCategory);
    }

    function getCategoriesForFilters(discipline, regions) {
      return getAvailableOptions('category', discipline, regions, '');
    }

    function getRegionsForCategory(category) {
      return getAvailableOptions('region', selectedDiscipline, [], category);
    }

    function getDisciplinesForCategory(category) {
      return getAvailableOptions('discipline', '', selectedRegions, category);
    }

    function getCountForOption(filterType, optionValue, selectedDiscipline, selectedRegions, selectedCategory) {
      let count = 0;
      slides.forEach(slide => {
        // For the filter we're counting, use the option value
        // For other filters, use the selected values
        let matchesDiscipline = true;
        let matchesRegion = true;
        let matchesCategory = true;

        if (filterType === 'discipline') {
          matchesDiscipline = optionValue === slide.discipline;
          matchesRegion = selectedRegions.length === 0 || slide.regions.some(region => selectedRegions.includes(region));
          matchesCategory = !selectedCategory || selectedCategory === slide.category;
        } else if (filterType === 'region') {
          matchesDiscipline = !selectedDiscipline || selectedDiscipline === slide.discipline;
          matchesRegion = slide.regions.includes(optionValue);
          matchesCategory = !selectedCategory || selectedCategory === slide.category;
        } else if (filterType === 'category') {
          matchesDiscipline = !selectedDiscipline || selectedDiscipline === slide.discipline;
          matchesRegion = selectedRegions.length === 0 || slide.regions.some(region => selectedRegions.includes(region));
          matchesCategory = optionValue === slide.category;
        }

        if (matchesDiscipline && matchesRegion && matchesCategory) {
          count++;
        }
      });
      return count;
    }

    function updateAllFilters() {

      // Update region filters based on current discipline and category
      const availableRegions = getAvailableOptions('region', selectedDiscipline, [], selectedCategory);
      $regionFilters.forEach(filter => {
        if (filter.value === 'all') return;
        const filterWrapper = filter.closest('li');
        const label = filterWrapper.querySelector('label');

        if (availableRegions.includes(filter.value)) {
          filterWrapper.style.display = '';
          // Update count
          const count = getCountForOption('region', filter.value, selectedDiscipline, [], selectedCategory);
          const countSpan = label.querySelector('span');
          if (countSpan) {
            countSpan.textContent = `(${count})`;
          }
        } else {
          filterWrapper.style.display = 'none';
          if (filter.checked) {
            filter.checked = false;
            const index = selectedRegions.indexOf(filter.value);
            if (index !== -1) selectedRegions.splice(index, 1);
          }
        }
      });

      // Update discipline filters based on current regions and category
      const availableDisciplines = getAvailableOptions('discipline', '', selectedRegions, selectedCategory);
      $disciplineFilters.forEach(filter => {
        if (filter.value === 'all') return;
        const filterWrapper = filter.closest('li');
        const label = filterWrapper.querySelector('label');

        if (availableDisciplines.includes(filter.value)) {
          filterWrapper.style.display = '';
          // Update count
          const count = getCountForOption('discipline', filter.value, '', selectedRegions, selectedCategory);
          const countSpan = label.querySelector('span');
          if (countSpan) {
            countSpan.textContent = `(${count})`;
          }
        } else {
          filterWrapper.style.display = 'none';
          if (filter.checked && filter.value === selectedDiscipline) {
            filter.checked = false;
            selectedDiscipline = '';
          }
        }
      });

      // Update category filters based on current discipline and regions
      const availableCategories = getAvailableOptions('category', selectedDiscipline, selectedRegions, '');
      $categoryFilters.forEach(filter => {
        if (filter.value === 'all') return;
        const filterWrapper = filter.closest('li');
        const label = filterWrapper.querySelector('label');

        if (availableCategories.includes(filter.value)) {
          filterWrapper.style.display = '';
          // Update count
          const count = getCountForOption('category', filter.value, selectedDiscipline, selectedRegions, '');
          const countSpan = label.querySelector('span');
          if (countSpan) {
            countSpan.textContent = `(${count})`;
          }
        } else {
          filterWrapper.style.display = 'none';
          if (filter.checked && filter.value === selectedCategory) {
            filter.checked = false;
            selectedCategory = '';
          }
        }
      });
    }

    function updateURL() {
      const params = new URLSearchParams();
      if (selectedRegions.length > 0) {
        params.set('selected_regions', selectedRegions.join(','));
      }
      if (selectedDiscipline) {
        params.set('selected_discipline', selectedDiscipline);
      }
      history.pushState(null, '', `${location.pathname}?${params}`);
    }

    function updateFilterStatus() {
      $regionFilters.forEach(el => {
        const val = el.getAttribute('value');
        const selected = selectedRegions.includes(val);
        if (selected || (selectedRegions.length == 0 && val === 'all')){
          el.checked = true;
          el.setAttribute('checked', '');
        } else {
          el.checked = false;
          el.removeAttribute('checked');
        }
      });

      $disciplineFilters.forEach(el => {
        const val = el.getAttribute('value');
        if ((val === selectedDiscipline) || (selectedDiscipline === '' && val === 'all')) {
          el.checked = true;
          el.setAttribute('checked', '');
        } else {
          el.checked = false;
          el.removeAttribute('checked');
        }
      });

      $categoryFilters.forEach(el => {
        const val = el.getAttribute('value');
        if ((val === selectedCategory) || (selectedCategory === '' && val === 'all')) {
          el.checked = true;
          el.setAttribute('checked', '');
        } else {
          el.checked = false;
          el.removeAttribute('checked');
        }
      });
    }

    function createInlineTag(label, value, type) {
      return `
        <span class="rounded-5fx pl-14fx pr-4fx t:bg-#F7ECD9 t:pl-[6px] t:pr-[1px] t:py-[0px] flex items-center justify-start t:mb-8fx r:mr-5fx space-x-3fx hover:bg-#f5ecdb mr-4px">
            <span>${label}</span>
            <button 
              data-filter-tag-delete
              data-type="${type}" 
              data-value="${value}"
              class="p-10fx border-none bg-none m:p-[5px]"
              style="font-size: 0;">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" class="w-16fx">
                <path d="M2.78218 2.9541L2.85932 2.86177C3.09075 2.63034 3.44998 2.60463 3.7098 2.78463L3.80213 2.86177L7.9974 7.05717L12.1927 2.86177C12.453 2.60142 12.8751 2.60142 13.1355 2.86177C13.3958 3.12212 13.3958 3.54423 13.1355 3.80457L8.94006 7.99984L13.1355 12.1951C13.3669 12.4265 13.3926 12.7858 13.2126 13.0456L13.1355 13.1379C12.904 13.3693 12.5448 13.395 12.285 13.215L12.1927 13.1379L7.9974 8.9425L3.80213 13.1379C3.54178 13.3983 3.11967 13.3983 2.85932 13.1379C2.59898 12.8776 2.59898 12.4554 2.85932 12.1951L7.05473 7.99984L2.85932 3.80457C2.6279 3.57315 2.60219 3.21392 2.78218 2.9541L2.85932 2.86177L2.78218 2.9541Z" fill="#5D524B"/>
              </svg>
            </button>    
        </span>
      `;
    }

    function updateInlineFiltersSection(numResults) {
      $selectedFilters.innerHTML = `<span class="t:mb-8fx">${numResults + ' result' + (numResults>1?'s':'')}</span>`;
      if (selectedDiscipline || selectedRegions.length>0 || selectedCategory) {
        $selectedFilters.innerHTML += `
          <div class="space-x-4px">
            <span class="t:mb-8fx mx-20fx w-[1px] h-20fx bg-[rgba(93,82,75,0.5)] inline-block m:mx-[10px]"></span>
          </div>
        `;
      }
      if (selectedDiscipline) {
        $selectedFilters.innerHTML += createInlineTag(
          cleanTitles.discipline[selectedDiscipline] || selectedDiscipline,
          selectedDiscipline,
          'discipline'
        );
      }
      selectedRegions.forEach(region => {
        $selectedFilters.innerHTML += createInlineTag(
          cleanTitles.region[region] || region,
          region,
          'region'
        );
      });
      if (selectedCategory) {
        $selectedFilters.innerHTML += createInlineTag(
          cleanTitles.category[selectedCategory] || selectedCategory,
          selectedCategory,
          'category'
        );
      }
    }

    $selectedFilters.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-filter-tag-delete]');
      if (!btn) return;
      const type = btn.getAttribute('data-type');
      const value = btn.getAttribute('data-value');
      if (type === 'discipline') {
        selectedDiscipline = '';
        $disciplineFilters.forEach(f => f.value === 'all' && (f.checked = true));
      }
      if (type === 'region') {
        selectedRegions = selectedRegions.filter(r => r !== value);
        if (selectedRegions.length === 0) {
          const all = this.querySelector('[data-region-filter][value="all"]');
          if (all) all.checked = true;
        }
      }
      if (type === 'category') {
        selectedCategory = '';
        $categoryFilters.forEach(f => f.value === 'all' && (f.checked = true));
      }
      filter();
    });

    // -----------------------------
    // Visual paging
    // -----------------------------

    function applyVisibility() {
      let shown = 0;
      let totalVisible = 0;

      slides.forEach(slide => {
        if (slide.el.style.display === 'none') {
          slide.el.classList.add('hidden-by-limit');
        } else {
          totalVisible++;
          if (shown < visibleLimit) {
            slide.el.classList.remove('hidden-by-limit');
            shown++;
          } else {
            slide.el.classList.add('hidden-by-limit');
          }
        }
      });

      // toggle Load More button
      if (visibleLimit >= totalVisible) {
        $loadMoreBtn.style.display = 'none';
      } else {
        $loadMoreBtn.style.display = '';
      }
    }

    // -----------------------------
    // Filtering
    // -----------------------------

    function filterPosts() {
      let visibleCount = 0;

      slides.forEach(slide => {

        let matchAnyRegion = selectedRegions.length == 0;
        let matchDiscipline = selectedDiscipline === '';
        let matchCategory = selectedCategory === '';

        let matchQuery = true;
        // if (query.length >= 3) {
          // const q = query
          //   .toLowerCase()
          //   .normalize("NFD")
          //   .replace(/[\u0300-\u036f]/g, "")
          //   .replace(/[^a-z0-9\s]/g, " ")
          //   .replace(/\s+/g, " ")
          //   .trim();
          // const title = slide.title
          //   .toLowerCase()
          //   .normalize("NFD")
          //   .replace(/[\u0300-\u036f]/g, "")
          //   .replace(/[^a-z0-9\s]/g, " ")
          //   .replace(/\s+/g, " ")
          //   .trim();
          // const words = q.split(" ");
          // matchQuery = words.every(word => title.includes(word));

          const qNorm = normalizeText(query);
          matchQuery = fuzzyMatchAllTokens(qNorm, slide.titleWords);

        // }
        
        slide.regions.forEach(slideRegion => {
          if (selectedRegions.includes(slideRegion)) {
            matchAnyRegion = true;
          }
        });

        if (selectedDiscipline === slide.discipline) {
          matchDiscipline = true;
        }

        if (selectedCategory === slide.category) {
          matchCategory = true;
        }

        if (!matchAnyRegion || !matchDiscipline || !matchCategory || !matchQuery) {
          slide.el.style.display = 'none';
        } 
        else {
          slide.el.style.removeProperty('display');
          visibleCount++;
        }
      });

      if (visibleCount === 0) {

        $noResultsMessage.classList.remove('hidden');
        $noResultsMessage.querySelectorAll('button')?.forEach(el => {
          el.removeAttribute('tabindex');
        });
      
        $jobsContainer.classList.add('hidden');

      } 
      else {

        $noResultsMessage.classList.add('hidden');
        $noResultsMessage.querySelectorAll('button')?.forEach(el => {
          el.setAttribute('tabindex', -1);
        });

        $jobsContainer.classList.remove('hidden');
      }

      updateFilterStatus();
      applyVisibility();
      updateInlineFiltersSection(visibleCount);

      $viewJobsButton.innerHTML = `View ${visibleCount} job${visibleCount>1?'s':''}`;
    }

    // -----------------------------
    // Tag state updater
    // -----------------------------
    const $filterTags = this.querySelectorAll('[data-filter-tag]');

    function updateTagStates() {
      $filterTags.forEach(tag => {
        const filterType = tag.getAttribute('data-filter-tag');
        const filterValue = tag.getAttribute('data-filter-value');

        let isActive = false;
        if (filterType === 'discipline' && selectedDiscipline === filterValue) {
          isActive = true;
        } else if (filterType === 'category' && selectedCategory === filterValue) {
          isActive = true;
        }

        if (isActive) {
          tag.classList.add('active-filter');
          tag.style.filter = 'brightness(0.97)';
        } else {
          tag.classList.remove('active-filter');
          tag.style.filter = '';
        }
      });
    }

    // -----------------------------
    // Event listeners
    // -----------------------------
    $searchInput.addEventListener('input', (e)=>{
      query = $searchInput.value;
      $searchClear.style.display = query == '' ? 'none' : 'block';
      filter();
      console.log('INOUT CHNAGED')
    });
    $searchInput.addEventListener("keydown", (e) => {
      // ignore IME composition  
      if (e.isComposing) return;
      // "Enter" key + fallback to keyCode
      const isEnter = e.key === "Enter" || e.keyCode === 13;
      if (!isEnter) return;
      e.preventDefault(); // prevent form submit / newline behavior
      e.stopPropagation();
      e.currentTarget.blur(); // closes iOS keyboard
    });

    $regionFilters.forEach(el => {
      el.addEventListener('change', ()=>{
        const slug = el.getAttribute('value');
        if (slug == 'all') {
          selectedRegions = [];
          $regionFilters.forEach(f => { if (f !== el) f.checked = false; });
        } 
        else {
          selectedRegions = [slug];
          const allRegionFilter = this.querySelector('[data-region-filter][value="all"]');
          if (allRegionFilter) allRegionFilter.checked = false;
        }
        filter();
      });
    });


    $disciplineFilters.forEach(el => {
      el.addEventListener('change', ()=>{
        const slug = el.getAttribute('value');
        $disciplineFilters.forEach(f => {
          if (f !== el) {
            f.checked = false;
            f.removeAttribute('checked');
          }
        });

        if (slug === 'all') {
          selectedDiscipline = '';
        } else {
          selectedDiscipline = el.checked ? slug : '';
          if (!el.checked) {
            const allDisciplineFilter = this.querySelector('[data-discipline-filter][value="all"]');
            if (allDisciplineFilter) {
              allDisciplineFilter.checked = true;
            }
          }
        }
        filter();
      });
    });

    $categoryFilters.forEach(el => {
      el.addEventListener('change', ()=>{
        const slug = el.getAttribute('value');
        $categoryFilters.forEach(f => {
          if (f !== el) {
            f.checked = false;
            f.removeAttribute('checked');
          }
        });
        if (slug === 'all') {
          selectedCategory = '';
        } 
        else {
          selectedCategory = el.checked ? slug : '';
          if (!el.checked) {
            const allCategoryFilter = this.querySelector('[data-category-filter][value="all"]');
            if (allCategoryFilter) {
              allCategoryFilter.checked = true;
            }
          }
        }
        filter();
      });
    });

    // -----------------------------
    // Load more button
    // -----------------------------
    $loadMoreBtn.addEventListener('click', () => {
      visibleLimit += LOAD_MORE_INCREMENT;
      applyVisibility();
    });

    // -----------------------------
    // Tag click handlers
    // -----------------------------
    $filterTags.forEach(tag => {
      tag.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();

        const filterType = tag.getAttribute('data-filter-tag');
        const filterValue = tag.getAttribute('data-filter-value');

        // Save current scroll position
        const currentScrollY = window.scrollY;

        // Toggle the appropriate filter
        if (filterType === 'discipline') {
          if (selectedDiscipline === filterValue) {
            // Turn off filter
            selectedDiscipline = '';
            // Select "All" in radio buttons
            $disciplineFilters.forEach(f => {
              if (f.value === 'all') {
                f.checked = true;
                f.setAttribute('checked', '');
              } else {
                f.checked = false;
                f.removeAttribute('checked');
              }
            });
          } else {
            // Turn on filter
            selectedDiscipline = filterValue;
            // Update radio buttons
            $disciplineFilters.forEach(f => {
              if (f.value === filterValue) {
                f.checked = true;
                f.setAttribute('checked', '');
              } else {
                f.checked = false;
                f.removeAttribute('checked');
              }
            });
          }
        } else if (filterType === 'category') {
          if (selectedCategory === filterValue) {
            // Turn off filter
            selectedCategory = '';
            // Select "All" in radio buttons
            $categoryFilters.forEach(f => {
              if (f.value === 'all') {
                f.checked = true;
                f.setAttribute('checked', '');
              } else {
                f.checked = false;
                f.removeAttribute('checked');
              }
            });
          } else {
            // Turn on filter
            selectedCategory = filterValue;
            // Update radio buttons
            $categoryFilters.forEach(f => {
              if (f.value === filterValue) {
                f.checked = true;
                f.setAttribute('checked', '');
              } else {
                f.checked = false;
                f.removeAttribute('checked');
              }
            });
          }
        }
        filter();
        // Restore scroll position to prevent page jump
        window.scrollTo(0, currentScrollY);

        console.log('BlockCareers:scrollto');
        
      });
    });



    // -----------------------------
    // Init
    // -----------------------------
    filterPosts();
    // If there are pre-selected filters from URL, update all filters
    if (selectedDiscipline || selectedRegions.length > 0 || selectedCategory) {
      updateAllFilters();
    }
    // Update tag states on init
    updateTagStates();

    $filtersMenuReset.style.opacity = hasfilters() ? 1 : 0

  }
}

customElements.define('block-careers', BlockCareers);
